export default String.raw`
@media screen and (max-width: 1439px) {
    .footer {
        padding: 32px;
        &__main, &__main.more-columns {
            grid-template-columns: repeat(3, minmax(215px, 1fr));
        }
        &__section {
            &.contact-section {
                grid-column: auto;
                grid-row: auto;
                justify-self: unset;
            }
        }
    }
}
`